
<template>
  <div>
     <LinkTitle></LinkTitle>
     <div class = "contentWrap">
       <div @click = "itemClick(item)" class = "item" v-for = "(item,index) in data" :key = "index">
         <img class='img' :src="item.img" alt="">
         <div class = "itemText">
           <div @mouseover="mouseOver"	@mouseleave="mouseLeave"  :style="active" class = "title">{{item.title}}</div>
           <div class = "subTitle">{{item.subTitle}}</div>
         </div>
       </div>
     </div>
    <div @click = "changeAlipay" v-show = "alipayState" class = "alipay"></div>
    <div @click = "changeAlipay" v-show = "alipayState" class = "alipayImgWrap">
      <img class='alipayImg' src="@/assets/alipay.png" alt="">
     </div>
     <Footer></Footer>
  </div>
</template>

<script>
export default {

  data() {
    return {
      active:'',
      alipayState:false,
      data:[
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-nongchanpin1.jpg',
          title:'2019年第52周国内外农产品市场动态',
          subTitle:'据农业农村部监测，2019年第52周（2019年12月23日—12月29日，下同）“农产品批发价格200指数”为124.46（以2015年为100），比前一周升0.48个点；“‘菜篮子’产品批发价格200指数”为128.01（以2015年为100），比前一周升0.56个点。重点监测的50家批发市场60个品种交易总量为50.23万吨，环比减2.7%.鸡蛋、猪肉价格继续小幅下跌.水产品价格小幅下跌.蔬菜均价略有上涨.水果均价小幅上涨'
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-zhuroubaitiao2.jpg',
          title:'2020年第1周瘦肉型白条猪肉出厂价格监测周报',
          subTitle:'据农业农村部信息中心和山东卓创资讯股份有限公司联合监测，2020年第1周（即2019年12月30日-2020年1月3日，以下简称本周），16省（直辖市）瘦肉型白条猪肉出厂价格总指数的周平均值为每公斤45.48元，环比涨3.4%，同比涨159.7%。 本周国内瘦肉型白条猪肉出厂价格(以下简称猪肉价格)环比上涨。大体重生猪存栏量明显降低，养殖户惜售情绪渐浓，加之规模养殖场看涨后市，减少生猪出栏量。致使市场供应紧张，支撑生猪和猪肉价格上涨。'
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-Zhutiming-sass3.jpg',
          title:'新商业，云拐点 2018-2019年中国SaaS市场洞察报告',
          subTitle:`随着经济结构、产业调整，TOP级省份与核心经济带的SaaS产业增速呈现低增速或负增速，单一的依赖SaaS级服务商，不足以推动SaaS产业在这些地区的的高速增长，与SaaS相关的配套服务存在市场空白，SaaS势如破竹之势遭遇截断。
• 但是，SaaS向不发达经济区域的快速拓展，为产业信息化水平的提高功不可没，传统信息化多年努力依然困于经济发达区域的魔咒被SaaS击破，
SaaS依然具有机会，向2、3线城市的下沉或许是SaaS的另外一个机会。`
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-qukuailian4.jpg',
          title:'2018 年区块链发展报告',
          subTitle:`近日，创业邦发布《2018 年区块链发展报告》，报告发现，区块链在有互信需
求、需要去中介平台提高交易效率以及拥有线上结构化数据的行业落地性会更
强。区块链应用将率先在金融领域落地，并逐渐向社会征信、文娱、供应链、
医疗、教育、物流等多领域渗透。区块链企业融资大都集中于 A 轮及 A 轮以前。`
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-zaixianfufei5.jpg',
          title:'中国在线知识付费市场研究报告',
          subTitle:`在线知识付费产业：广义“在线知识付费产业”指代以付费购买在线知识服务为核心衍生出的利益相关、分工不同、能够
在各自的产业环节内完成自循环的上下游业态集合体。本报告将聚焦于狭义“在线知识付费产业”，不含在线教育赛道。
在线知识付费类平台：不局限于独立知识付费平台，还包括开拓了知识付费功能、为其设立单独版块及一级入口的综合知
识付费类平台。
在线知识付费产品：即为付费在线知识服务产品，由用户出于明确的求知目的付费购买的在线碎片化知识服务凝结而成。`
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-Zhutiming-huobi6.jpg',
          title:'中国人民银行货币政策',
          subTitle:`2019 年上半年，中国经济增长保持韧性，继续运行在合理区间，
延续总体平稳、稳中有进的发展态势。结构调整继续推进，总供求基
本平衡。消费、投资增势平稳，贸易顺差同比有所扩大，物价和就业
形势保持稳定。但内外部不确定不稳定因素有所增加，经济仍存在下
行压力。`
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-yingxiao7.jpg',
          title:'营销技术趋势报告',
          subTitle:`自从美国电话电报公司在1994年推出了第一个横幅广告以来，广告
业就开始了翻天覆地的变化。随着广告技术的出现，新的渠道和设
备开始为广告客户提供不同的营销方式。
从90年代的流行音乐到1998年谷歌的首次亮相和2004年Facebook
的推出，广告技术有一个明确的方向：个性化。但广告商是如何朝
这个方向努力的呢？2019年及以后的广告技术会是什么样?`
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-hulianwangfuwu8.jpg',
          title:'互联网服务能力发展报告',
          subTitle:`党的十八大以来，党中央重视互联网、发展互联网、治理互联网，走出了一
条中国特色治网之道，形成了网络强国战略思想。作为网络强国的重要组成部分，
地方政府互联网服务能力对推进国家治理能力和治理体系现代化具有重要作用。
2018 年，各地方政府大力推进互联网服务创新，中国地方政府互联网服务能力
发展呈现出新态势、表现出新特征、取得了新进展。`
        },
        {
          img:'https://meat.chinausmeat.com/group1/M00/00/1E/pc-toutiao-dongtaitu-dianshang9.jpg',
          title:'中国工业品电商发展报告核心解读',
          subTitle:`中国工业品流通市场已达十万亿体量，但仍伴随增速放缓、产能利用率不高等现状自2010年开始工业产业增加值增长率由12.6%一路下滑至6.1%，与此同时，工业产能利用率虽在2016、2017年间表现连续回升，但2018年来又出现回落，整体
来讲，我国工业产业增加值表现出放缓趋势。但，2018年整个工业增加值突破30万亿，如果生产加工过程所需采购商品及服务占比达到25—30%，则国内工业品需
求市场能达到10万亿左右，其中还并不包括国外制造型企业对中国制造的需求。因此，当务之急，更需要引入新的产业模式及商业形态来刺激工业领域的经济生长。`
        }
      ]
    };
  },

  props: ["gid"],

  components: {
  },

  created() {
  },

  mounted() {

  },

  methods: {
    mouseOver: function(){
        // this.active = 'color:#00a0e8'
    },
    mouseLeave: function () {
        // this.active = '';
    },
    itemClick(item){
      this.alipayState = true
      console.log(item)
    },
    changeAlipay() {
      this.alipayState = false
    }
  },

  computed: {}

};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .alipay {
      width:100%;
      height:100%;
      position:fixed;
      background-color:#140909;
      opacity:0.5;
      top:0;
      left:0;
      display:flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .alipayImgWrap {
      width:100%;
      height:100%;
      position:fixed;
      top:0;
      left:0;
      z-index:100;
      display:flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .title:hover {
      color:#00a0e8
    }
    .contentWrap {
      width:1200px;
      padding:10px;
      margin:50px auto;

      .item {
        width:100%;
        height:200px;
        border:1px solid #ccc;
        display:flex;
        flex-direction:row;
        justify-content:space-between;
        align-items:center;
        margin-top:20px;
        padding:10px;
        border-radius:10px;
        img {
          width:420px;
          height:100%;
        }
        .itemText {
          width:760px;
          height:100%;
          // border:1px solid purple;
          .title {
            font-size:30px;
            color:#303030;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          // .item:hover {
          //   color:#00a0e8;
          // }
          .subTitle {
            font-size:20px;
            color:#999999;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/IndustryInformation.vue